import * as React from 'react'

export function createContext<A, P>(
  useStateFn: (_props: P) => A,
  name?: string,
): readonly [() => A, (_props: React.PropsWithChildren<P>) => React.JSX.Element, React.Context<A | undefined>] {
  const Context = React.createContext<A | undefined>(undefined)

  Context.displayName = name

  function useCtx(): A {
    const c = React.useContext(Context)
    if (!c) {
      throw new Error('useContext must be inside a Provider with a value')
    }
    return c
  }

  function Provider(props: React.PropsWithChildren<P>): React.JSX.Element {
    const state = useStateFn(props)
    return <Context.Provider value={state} {...props} />
  }

  // make TypeScript infer a tuple, not an array of union types
  return [useCtx, Provider, Context] as const
}
